<script setup>
import ProspectForm from '@frontJs/components/forms/projectManagement/apikom/ProspectForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { prospect } = defineProps({
    prospect: {
        type: Object,
        required: false,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title v-if="prospect">
            Mettre à jour le prospect #{{ prospect.id }} - Prospects - Apikom -
            Gestion de projet - Datakepler
        </title>

        <title v-else>
            Créer un prospect - Prospects - Apikom - Gestion de projet -
            Datakepler
        </title>
    </Head>

    <PageTitle v-if="prospect">
        Gestion de projet - Apikom - Prospects - Mettre à jour le prospect #{{
            prospect.id
        }}
    </PageTitle>

    <PageTitle v-else>
        Gestion de projet - Apikom - Prospects - Créer un prospect
    </PageTitle>

    <ProspectForm :prospect="prospect" />
</template>
